import { Stack, Button, Typography, Card, Grid, Box } from "@mui/material";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
import axios from "axios";

import addCount from "Helper/addCount";

import { API_URL } from "Constants";

interface INumeric {
  id: number;
  ip: string;
}
interface IHttps {
  name: string;
  link: string;
}

export default function DNS() {
  const { data } = useQuery({
    queryKey: ["dns"],
    queryFn: (): Promise<{ numeric: INumeric[]; https: IHttps[] }> => axios.get(`${API_URL}/dns`).then((res) => res.data),
  });

  const handleCopyDns = (dns: INumeric) => {
    addCount("dns", dns.id);
    handleCopy(dns.ip);
  };
  const handleCopy = (value: any) => {
    var input = document.createElement("input");
    input.setAttribute("value", value);
    input.select();
    input.setSelectionRange(0, 99999);

    navigator.clipboard.writeText(input.value);
    toast.success("با موفقیت کپی شد");
  };

  return (
    <Card sx={{ p: 3 }}>
      <Stack alignItems="center" mb={5}>
        <Typography variant="h4" fontWeight="700" sx={{ color: "error.main" }}>
          دی‌ان‌اس‌‌ها
        </Typography>
      </Stack>

      <Grid container columnSpacing={1} rowGap={1} justifyContent="space-between">
        <Grid item xs={12} md={5.5}>
          <Grid container justifyContent="center" columnSpacing={2} rowGap={3}>
            {data?.numeric.map((i, index) => (
              <Grid item xs={12} md={10}>
                <Stack spacing={1}>
                  <Typography sx={{ color: "text.secondary" }}>
                    آیپی {index === 0 ? "اول" : "دوم"} (برای کپی کلیک کنید)
                  </Typography>

                  <Button variant="contained" color="error" sx={{ fontSize: "25px" }} onClick={() => handleCopyDns(i)}>
                    {i.ip}
                  </Button>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Grid>

        <Grid item xs={1}>
          <Box sx={{ width: "1px", height: "100%", bgcolor: "#aaa", mx: "auto" }} />
        </Grid>

        <Grid item xs={12} md={5.5}>
          <Grid container justifyContent="center" columnSpacing={2} rowGap={3}>
            {data?.https.map((i) => (
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <Typography sx={{ color: "error.main", fontWeight: "700" }} align="center">
                    {i.name} (برای کپی کلیک کنید)
                  </Typography>

                  <Box
                    onClick={() => handleCopy(i.link)}
                    sx={{
                      width: "100%",
                      bgcolor: "#efefef",
                      px: 2,
                      height: "55px",
                      borderRadius: 3,
                      color: "#333",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "0.4s",
                      cursor: "pointer",

                      "&:hover": {
                        bgcolor: "#dddddd",
                      },
                    }}
                  >
                    {i.link}
                  </Box>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}
